import MessageIcon from '@/assets/icons/icon-sent-mail.svg';
import { socialMediaIcons } from '@/components/layouts-and-navs/constants';

const ThankYouMessage = () => {
  return (
    <div className='flex flex-col items-center gap-[18px] pt-[94px] !bg-transparent'>
      <MessageIcon className='relative z-[1]' />
      <div className='flex flex-col gap-[4px] lg:gap-[9px] items-center !bg-transparent'>
        <p className='text-[25px] lg:text-[33px] font-semibold text-coal-250 text-center relative z-[1]'>
          Thank you for contacting <span className='text-[25px] lg:text-[33px] font-semibold text-primary'>NettyWorth.</span>
        </p>
        <p className='text-base lg:text-lg font-normal relative z-[1]'>Your message has been received.</p>
      </div>
      <div className='flex gap-6 pt-5 pb-[35px] !bg-transparent'>
        {socialMediaIcons.map((social) => {
          const SocialIcon = social.icon;
          return (
            <a href={social.path} target='_blank' key={social.path} className='flex justify-center items-center relative z-[1]' rel='noreferrer'>
              <SocialIcon className='fill-primary' />
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default ThankYouMessage;
